import {forwardRef} from 'react';

import aiAssistantAuraBlobs, {
    AURA_BLOB_CLASS,
    AURA_CANVAS,
    AURA_HEIGHT,
    AURA_WIDTH,
} from '../../../consts/aiAssistant/aiAssistantAuraBlobs';
import {twx} from '../../../utils/tailwindUtils';
import Icon from '../Icon';

const {x, y, width, height} = AURA_CANVAS;

const VIEWBOX = `${x} ${y} ${width} ${height}`;

// Aligns each blob's SVG box with the artwork
const CANVAS_STYLE = {
    left: `${(x / AURA_WIDTH) * 100}%`,
    top: `${(y / AURA_HEIGHT) * 100}%`,
    width: `${(width / AURA_WIDTH) * 100}%`,
    height: `${(height / AURA_HEIGHT) * 100}%`,
};

const getBlobOrigin = (center) => `${((center.x - x) / width) * 100}% ${((center.y - y) / height) * 100}%`;

// One SVG per blob, so the GPU blurs each once - a shared SVG with filters re-blurred on the CPU (30fps on iPhone)
const AiAssistantAuraIcon = ({className}, ref) => (
    // Artwork fitted to the width and centred in 107px, so the collapsed pill shows the blob cores below it
    <div ref={ref} className={twx('ai-assistant-aura relative h-[107px] overflow-hidden', className)}>
        <div className='absolute inset-x-0 top-1/2 aspect-[353/107] -translate-y-1/2'>
            {aiAssistantAuraBlobs.map(({d, fill, center}) => (
                <Icon
                    key={d}
                    viewBox={VIEWBOX}
                    className={twx(AURA_BLOB_CLASS, 'absolute')}
                    style={{...CANVAS_STYLE, transformOrigin: getBlobOrigin(center)}}
                >
                    <path d={d} fill={fill} />
                </Icon>
            ))}
        </div>
    </div>
);

export default forwardRef(AiAssistantAuraIcon);
